import React, { Component } from 'react';
import { Link } from 'react-router';

var WriteMessageStatus = React.createClass({
  handlerChangeMessage: function(failureStatusId){
    // console.log(this.state.message, failureStatusId);
    if(failureStatusId && Number.isInteger(failureStatusId)){
      this.props.actionChangeMessageStatus(false, failureStatusId);
    }else if(this.state.message){
      this.props.actionChangeMessageStatus(this.state.message);
    }else{
      this.props.closeChangeMessageStatus();
    }


  },
  handlerTestKey: function(event){
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!/^[a-zA-Z]| |[а-яА-Я]|[0-9]|,|\.|!|:|-|\$|#|@|%|&|\*|\(|\)|\+|=|\?+$/.test(key)) {
        event.preventDefault();
        return false;
    }
  },
  handlerChangeMessageState: function(event){
    this.setState({message: event.target.value});
  },
  getInitialState: function(){
    return({message: ''})
  },
  render: function(){
    var THIS = this;
    if(this.props.failureStatuses && this.props.failureStatuses.length && this.props.status == '0'){
      return(
        <div className="table-cell">
          <h1 className="emptyHeadline">Почему вы так решили?</h1>
          {this.props.failureStatuses.map(function(item){
            return(
              <div className="SelectSpecialtiesOpen" style={{margin: '0', marginTop: '10px'}} onClick={function(){
                THIS.handlerChangeMessage(item.id)
              }}>{item.name}</div>
            )
          })}
        </div>
      )
    }
    return(
      <div className="table-cell">
        <h1 className="emptyHeadline">Почему вы так решили?</h1>
        <textarea defaultValue={this.state.message} className={this.props.error ? 'error' : ''} onKeyPress={this.handlerTestKey} onChange={this.handlerChangeMessageState} />
        <div className="SelectSpecialtiesOpen" style={{margin: '0', marginTop: '10px'}} onClick={this.handlerChangeMessage}>Ок!</div>
      </div>
    )
  }
});

export default WriteMessageStatus;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Profile/components/WriteMessageStatus/index.jsx
 **/